import fetch from 'lib/fetch'
import Cookies from 'js-cookie'
import { apiV3BLLaunchdDarklyFlagPath } from 'lib/urls'
import { LDContext } from './ldContext'
import { isPrerenderUserAgent } from '../isPrerenderUserAgent'
import { getCurrentUser } from 'shared/utils/getCurrentUser/getCurrentUser'

/*
    This function is used to get the value of a particular flag.
    This is an async function because we need to wait for the context to set.

    **This should _NOT_ be used for pages that are Server Side Rendered!**
    Server Side Rendered pages should pass the flag value to the React component
    via the erb template.

    https://docs.launchdarkly.com/sdk/features/identify?q=iden#javascript
*/

export const ldGetFlag = async (
  context: LDContext,
  flagName: string,
  defaultValue: boolean | string
) => {
  if (
    typeof window === 'undefined' ||
    !context?.key ||
    context?.key === 'undefined' ||
    context?.key === '' ||
    isPrerenderUserAgent()
  ) {
    return defaultValue
  }
  const { client } = window.ldClient
  try {
    await client.identify(context)
    return client.variation(flagName, defaultValue)
  } catch (_e) {
    return defaultValue
  }
}

// This function will use the babylist API as a proxy and will not use the LD client
export const ldGetFlagV2 = (
  flagName: string,
  defaultValue: boolean | string
) => {
  if (typeof window === 'undefined' || isPrerenderUserAgent()) {
    return defaultValue
  }

  let flagValue = defaultValue
  const currentUser = getCurrentUser()
  if (currentUser?.ldFlags) {
    flagValue = currentUser.ldFlags[flagName]
  } else {
    // Read from cookie
    const blLdFlags = Cookies.get('bl_ld_flags')
    if (blLdFlags) {
      const ldFlags = JSON.parse(blLdFlags)
      flagValue = ldFlags[flagName]
    }
  }

  const path = `${apiV3BLLaunchdDarklyFlagPath}?flag_name=${flagName}`
  fetch(path, { method: 'GET' })

  return flagValue
}
